import { css } from "../../styles";

export const quillCss = css({
  ".ql-toolbar": {
    border: "0px !important",
    width: "fit-content",
    borderRadius: "6px",
    boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.20)",
    padding: "4px 16px 4px 16px !important",

    ".ql-formats": {
      marginRight: "0px !important",
      display: "flex !important",
      gap: "10px",

      button: {
        width: "28px",
        height: "28px",
        display: "flex",

        justifyContent: "center",
        alignItems: "center",

        borderRadius: "4px",

        "&:hover": {
          ".ql-stroke": {
            stroke: "#727272 !important",
            color: "#727272 !important",
          },
          ".ql-fill": {
            stroke: "#727272 !important",
            color: "#727272 !important",
            fill: "none",
          },
        },

        "&:focus": {
          outline:
            "2px solid var(--colors-portal-rich-text-editor-toolbar-focus-border) !important",

          ".ql-stroke": {
            stroke:
              "var(--colors-portal-rich-text-editor-toolbar-focus-icon) !important",
            color:
              "var(--colors-portal-rich-text-editor-toolbar-focus-icon) !important",
          },
          ".ql-fill": {
            stroke:
              "var(--colors-portal-rich-text-editor-toolbar-focus-icon) !important",
            color:
              "var(--colors-portal-rich-text-editor-toolbar-focus-icon) !important",
            fill: "none",
          },
        },

        "&.ql-active": {
          backgroundColor:
            "var(--colors-portal-rich-text-editor-toolbar-active-background)",

          ".ql-stroke": {
            stroke:
              "var(--colors-portal-rich-text-editor-toolbar-active-icon) !important",
            color:
              "var(--colors-portal-rich-text-editor-toolbar-active-icon) !important",
          },
          ".ql-fill": {
            stroke:
              "var(--colors-portal-rich-text-editor-toolbar-active-icon) !important",
            color:
              "var(--colors-portal-rich-text-editor-toolbar-active-icon) !important",
            fill: "none",
          },
        },
      },
    },
  },

  ".ql-container": {
    fontSize: "inherit !important",
  },

  ".ql-stroke": {
    fill: "none",
    stroke: "#939393 !important",
  },

  ".ql-toolbar .ql-fill": {
    fill: "none",
    stroke: "#939393",
  },

  ".ql-toolbar .ql-picker": {
    color: "#939393",
  },

  ".ql-editor": {
    fontFamily: "$openSans !important",
    color: "#212121",
    fontSize: "inherit",
  },

  ".ql-blank::before": {
    fontStyle: "normal !important",
  },

  ".ql-editor .mention": {
    backgroundColor: "transparent",
    color: "#1A73E8",
    fontWeight: "500",
    padding: "0",
  },
  ".ql-editor .mention > span": {
    margin: "0",
  },
  ".ql-editor .mention .ql-mention-denotation-char": {
    color: "#1A73E8",
  },

  ".ql-mention-list-container": {
    zIndex: 9999,
    width: "max-content !important",
    minWidth: "270px",
    maxWidth: "480px",
    backgroundColor: "#FFFFFF",
    border: "1px solid #E6E6E6",
    borderRadius: "6px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
    maxHeight: "260px",
    overflowY: "auto",
    fontFamily: "$openSans",
  },
  ".ql-mention-list-item": {
    padding: "8px 12px",
    cursor: "pointer",
    fontSize: "14px",
    color: "#212121",
    lineHeight: "1.4",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  ".ql-mention-list-item.selected": {
    backgroundColor: "#F2F4F8",
  },
});

export const mobileQuilllCss = css(quillCss, {
  ".ql-container": {
    backgroundColor: "#FFFFFF !important",
    border: "none !important",
  },
});
